<div class="notification-pop-wrapper">
  <ion-card>
    <img style="padding-top: 25px" src="{{messageData?.template_data?.icon_url}}" />
    <ion-card-header>
      <h2 class="card-title">{{ messageData?.extract }}</h2>
    </ion-card-header>
    <ion-card-content>
      <p [innerHTML]="sanitizedMessage"></p>
      @if (messageData?.slide_to_buy?.slide_to_buy && slideToBuyBtnStatus) {
      <div class="foot-wrapper-promo inbox_button">
        <div class="slider-container">
          <div class="slider-text" [ngClass]="class">{{ buttonText }}</div>
          <div #slide_btn class="slider">
            <img src="assets/gif/rightarrow1.gif" alt="right arrow icon" />
          </div>
        </div>
      </div>
      } @else {
      <ion-button (click)="onCTA()" class="purple-btn">{{ messageData?.button_label }}</ion-button>
      }
    </ion-card-content>
  </ion-card>
</div>
<div class="pay-successs">
  <img src="assets/gif/final_lottie.gif" alt="Success animation" />
</div>
